var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subheader"},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.tooltip)?_c('Icon',{attrs:{"tooltip":_vm.tooltip,"name":"info"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }